import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../utils/useAuth';
import { loadRepOnlyNavigation } from '../utils/repOnlyNavigation';
import { queryPolicies } from '../utils/queryPolicies';

/**
 * REG-922: true for the Instantly partner (every group is Instantly Partner).
 * He reads his few deals and never submits them, so his grids open on all
 * dates and hide the submission composer. Shares the sidebar's cached query.
 */
export function useIsInstantlyPartner(): boolean {
  const { appUser } = useAuth();
  const repNavigation = useQuery({
    queryKey: ['rep-only-navigation', appUser?.id],
    queryFn: () => loadRepOnlyNavigation(appUser!.id),
    enabled: Boolean(appUser?.id),
    ...queryPolicies.permissions,
  });
  return repNavigation.data?.isInstantlyPartner === true;
}
